import { AxiosPromise } from "axios";
import { DesignDto, DesignResourceApi } from "../generated/dashboard-client";
import { dashboardApiConfig, ops } from "./config";
import { env } from "../env/env";
import { isStageEnv } from "../util/constants";

const api = new DesignResourceApi(dashboardApiConfig);

const DesignApi = {
  removeAll(ids: string[]): AxiosPromise<void> {
    return api.deleteDesigns(ids, ops());
  },

  putInFolder(
    ids: string[],
    folderId: number,
    oldFolderId?: number
  ): AxiosPromise<void> {
    return api.putInFolder(ids, folderId, oldFolderId, ops());
  },

  putFolderInFolder(
    childFolderId: number,
    parentFolderId: number
  ): AxiosPromise<void> {
    return api.addFolderToFolder(childFolderId, parentFolderId, ops());
  },

  removeFolderFromFolder(
    childFolderId: number
  ): AxiosPromise<void> {
    return api.removeFolderFromFolder(childFolderId, ops());
  },

  removeFromFolder(
    ids: string[]
  ): AxiosPromise<void> {
    return api.removeFromFolder(ids, ops());
  },

  overrideFolderCount(
    folderId: number,
    count: number
  ): AxiosPromise<void> {
    return api.overrideFolderCount(folderId, count, ops());
  },

  merge(ids: string[], name: string = "New Design"): AxiosPromise<DesignDto> {
    return api.merge(ids, name, ops());
  },

  copy(id: string, name: string): AxiosPromise<DesignDto> {
    return api.copy(id, { name }, ops());
  },

  rename(id: string, name: string, locationId: number): AxiosPromise<void> {
    return api.rename(id, { name, locationId }, ops());
  },

  changeLocation(id: string, locationId: number): AxiosPromise<void> {
    return api.changeLocation(id, { locationId }, ops());
  },

  changeLocationPDFUpload(id: string, locationId: number): AxiosPromise<void> {
    return api.changeLocationPDFUpload(id, { locationId }, ops());
  },

  changeFolder(id: string, folderId: number): AxiosPromise<void> {
    return api.changeFolder(id, { folderId }, ops());
  },

  getLightDesign(id: string): AxiosPromise<DesignDto> {
    return api.getDesign(id, ops());
  },

  registerDownload(id: string): Promise<Response> {
    return fetch(
      `${!isStageEnv ? env.basePath : ''}${env.timberContextPath}/api/designs/${id}/registerDownload`,
      {
        method: "PUT",
        headers: {
          Authorization: "Bearer " + window.localStorage.getItem("tkn"),
        },
      }
    );
  },

  downloadPdf(id: string, bleed: boolean): Promise<Response> {
    return fetch(
      `${env.rendererPath}/design/download/${id}.pdf?bleed=${bleed}`
    );
  },

  downloadUploadedPdf(id: string, name: string): Promise<Response> {
    return fetch(
      `/app/pdf/downloadUploaded?pdfId=${id}&name=${name}`
    );
  },

  downloadImage(id: string, type: string): Promise<Response> {
    return fetch(`${env.rendererPath}/design/download/${id}.${type}`);
  },

  downloadVideo(id: string, duration: number): Promise<Response> {
    return fetch(`${env.videoRendererPath}/design/download/${id}.mp4?duration=${duration}`);
  },

  getDesign(id: string) {
    return fetch(`${env.timberContextPath}/api/designs?id=${id}&complete=true`);
  },

  publish(id: string): AxiosPromise<void> {
    return api.publishDesign(id, ops());
  },

  getTemplateSets(templateId: string) {
    return fetch(`${env.timberContextPath}/api/templates/${templateId}/sets`);
  },
};

export default DesignApi;
